import React from 'react'
import Navbar from '../components/Navbar'
import IkinciElComp from '../components/IkinciEl_comp'
import Footer from '../components/Footer'

function IkinciElUrunler() {
  return (
    <div>
        <Navbar />
        <IkinciElComp />
        <Footer />
    </div>
  )
}

export default IkinciElUrunler
